import React from 'react'
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import FamilyFlexiReportsChild from './FamilyFlexiReportsChild';

const FamilyFlexiReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <FamilyFlexiReportsChild />
      </CardBackground>
    </MainTemplate>
  )
}

export default FamilyFlexiReports